/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useStore } from '../../store';
import PencilIcon from '../theme/pencilIcon';

const ImageFileUpload = ({
    setParent,
    setUrlVal,
    setProfileSrc,
    setOpen,
    setCropingModalOpen,
    updateParent = null,
    employeeImage,
    previousFiles = []
}) => {
    const { layoutStore } = useStore();
    const [fileDataArray, setFileDataArray] = useState([]);
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: ['image/jpeg', 'image/jpg', 'image/png'],
    });
    // const files = acceptedFiles.map((file, index) => (
    //     <li key={file.path} className="justify-between flex py-1 text-sm  text-gray-800">
    //         <p>{file.path} - {file.size} bytes</p>
    //         <p onClick={() => { setUrlVal(fileDataArray[index].data); setOpen(true); }} className="inline-block cursor-pointer font-medium text-blue-600 hover:text-blue-500">
    //             View
    //         </p>
    //     </li>
    // ));

    useEffect(() => {
        let sizeKb = acceptedFiles[0]?.size / 1024;
        console.log(sizeKb / 1024, "sizeKb")

        if (acceptedFiles.length > 0) {
            if (acceptedFiles.length && sizeKb > 10 && sizeKb < 5000) {
                Promise.all(
                    Array.from(acceptedFiles).map((file) => {
                        return new Promise((resolve) => {
                            const reader = new FileReader();

                            reader.onload = (e) => {
                                resolve({
                                    name: file.name,
                                    data: e.target.result,
                                });
                            };
                            reader.readAsDataURL(file);
                        });
                    })
                ).then((fileDataAsArray) => {
                    // Set the file data array in the same order as selected
                    setFileDataArray(fileDataAsArray);
                    setProfileSrc(fileDataAsArray[0].data)
                    setCropingModalOpen(true);
                });
            }
            if (acceptedFiles.length > 0 && sizeKb > 10 && sizeKb < 5000) {
                setParent(acceptedFiles);
            } else {
                layoutStore.showToaster("Please select the file valid types and size")
            }
        }

    }, [acceptedFiles]);
    return (
        <>
            <div
                {...getRootProps({ className: 'dropzone' })}
                className="relative flex justify-center w-32 h-32 cursor-pointer rounded-lg border-2 border-dashed border-gray-300 p-2 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                <input {...getInputProps()} />
                {employeeImage === '' && (
                    <span className="mt-1 block text-sm font-medium text-gray-900">
                        Drag and drop your Image files (png, jpg, jpeg) here, or <span className="text-blue-600 hover:text-blue-500">browse</span> (Max size 5 MB)
                    </span>
                )}
                {employeeImage && (
                    <img src={employeeImage || ''} alt="employeeImage" style={{ height: "100%" }} />
                )}
                <PencilIcon />
            </div>

            {/* <aside className='mt-4'>
                {acceptedFiles.length > 0 && (
                    <>
                        <h4 className="text-sm font-medium text-gray-500 pb-4">Files</h4>
                        <ul role="list" className="-my-5 divide-y divide-gray-200">
                            {acceptedFiles[0]?.size / 1024 > 10 && acceptedFiles[0]?.size / 1024 < 500 ? files : ''}
                        </ul>
                    </>
                )}
            </aside> */}
        </>
    );
}

export default ImageFileUpload;

